// extracted by mini-css-extract-plugin
export default {"quantity_wrapper":"CZ","increment":"EZ","decrement":"FZ","product":"GZ","product_info":"HZ","text":"IZ","modify_btn":"JZ","controls":"KZ","price":"LZ","deliveredOnce":"MZ"};
    if(module.hot) {
      // 1715188239337
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  